import { useTranslation } from "react-i18next";
import type { useWeightMacroTrackerBlock } from "./useWeightMacroTrackerBlock";
import { useMetricLabel } from "./useMetricLabel";

type TrackerState = ReturnType<typeof useWeightMacroTrackerBlock>;

export interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
}

/** Returns [] on the dashboard (root) view, matching the prototype's "don't show breadcrumbs on the root page" rule. */
export const useBreadcrumbs = (state: TrackerState): BreadcrumbItem[] => {
  const { t } = useTranslation("portal");
  const { metricLabel } = useMetricLabel();

  const currentLabel = (): string | undefined => {
    switch (state.view.name) {
      case "dashboard":
        return undefined;
      case "history":
        return t("History");
      case "metric-detail":
        return metricLabel(state.view.metricId);
      case "log-entry":
        return t("Log Entry");
    }
  };

  const label = currentLabel();
  if (label === undefined) return [];

  return [{ label: t("Overview"), onClick: state.goToDashboard }, { label }];
};
